<script>
import SkyList from 'sky-list';
import skySearchMixin from 'sky-search/sky-search.mixin';

const preferences = {
	api: '/umbraco/api/SiteSearchApi/search',
	pagination: true,
	fetchConditions: {
		keywords(keywords) {
			return keywords.length;
		},
	},
};

const parameters = {
	keywords: '',
};

export default {
	mixins: [skySearchMixin],
	data() {
		return {
			list: new SkyList(preferences, parameters),
			parameters,
		};
	},
	created() {
		/**
		 * Populate keywords from list in case it has intial value
		 * (from url string for instance)
		 */
		Object.keys(this.parameters).forEach((key) => {
			if (key in this.list.params) {
				this.parameters[key] = this.list.params[key];
			}
		});
	},
	watch: {
		parameters: {
			handler() {
				// Keep list params in sync
				Object.keys(this.parameters).forEach((key) => {
					if (this.list.params[key] !== this.parameters[key]) {
						this.list.params[key] = this.parameters[key];
						// Reset offset if params have changed
						this.list.params.offset = 0;
					}
				});
				this.update();
			},
			deep: true,
		},
	},
	methods: {
		update() {
			// Only update if keywords length is above 1
			if (this.parameters.keywords.length > 1) {
				this.list.update();
			} else {
				this.list.reset();
			}
		},
	},
};
</script>

<style src="./sky-search.scss"></style>
<template src="./sky-search.html"></template>



// WEBPACK FOOTER //
// sky-search.vue?46eeff58